import React from 'react'
import './application-card.css'

const ApplicationCard = (props) => {
    const turnNameIntoAbbreviation = () => {
        switch(props.application.key14app) {
            case 'Mountainside Music Academy':
                return 'MMA';
            case 'Lakeside Music Academy':
                return 'LSMA';
            case 'Treeside Music Academy':
                return 'TSMA';
            case 'Morningside Music Academy':
                return 'MOR';
            case 'Parkside Music Academy':
                return 'PSMA';
            default:
                return '';
        }
    }
    return(
        <div>
            <div className="task-card" id="task-card" onClick={() => props.toggleApplication(props.application)}>
                    <h4 className="task-card-name">{props.application.key1app} {props.application.key2app}'s Application</h4>
                    <h5 className="application-left">{turnNameIntoAbbreviation()}</h5>
                </div>
        </div>
    )
}
export default ApplicationCard